var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurpleStripes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 630,
    height: 309,
    viewBox: "0 0 630 309",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4415 544.83C19.9033 445.385 -70.8755 327.257 -116.198 280.624C-282.746 117.062 -647.092 -16.8622 -548.861 173.525C-470.389 325.615 -89.6514 502.209 62.5148 562.526",
    stroke: "#4824C1",
    strokeWidth: 7.0911
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M255.629 570.475C255.091 471.03 164.312 352.902 118.99 306.269C-47.5583 142.707 -411.904 8.78284 -313.673 199.17C-235.202 351.26 145.536 527.854 297.702 588.171",
    stroke: "#4824C1",
    strokeWidth: 7.0911
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M518 594.842C517.462 495.396 426.683 377.269 381.361 330.635C214.813 167.074 -149.533 33.1491 -51.3021 223.536C27.1694 375.627 407.907 552.22 560.073 612.537",
    stroke: "#4824C1",
    strokeWidth: 7.0911
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleStripes);
export default __webpack_public_path__ + "static/media/purpleStripes.a8dbfe19fff5e47d83948942f9932fa5.svg";
export { ForwardRef as ReactComponent };